import { createHeroIcon } from "#components/ui/createHeroIcon.tsx";

// Heroicons 20/solid "document-duplicate" (MIT)
const BACK_PAGE_PATH = [
    "M7 3.5A1.5 1.5 0 0 1 8.5 2h3.879a1.5 1.5 0 0 1 1.06.44l3.122 3.12A1.5 1.5 0 0 1 17 6.622V12.5",
    "a1.5 1.5 0 0 1-1.5 1.5h-1v-3.379a3 3 0 0 0-.879-2.121L10.5 5.379A3 3 0 0 0 8.379 4.5H7v-1Z"
].join("");
const FRONT_PAGE_PATH = [
    "M4.5 6A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06",
    "L9.44 6.439A1.5 1.5 0 0 0 8.378 6H4.5Z"
].join("");

export const HeroDocumentDuplicateIcon = createHeroIcon(
    <>
        <path d={BACK_PAGE_PATH} />
        <path d={FRONT_PAGE_PATH} />
    </>,
    "HeroDocumentDuplicateIcon"
);
